import { Component } from '@angular/core';
import { EmpresaService } from 'src/app/services/empresa.service';
import { Usuario, UsuarioSesion } from 'src/app/models/usuario-sesion.interface';
@Component({
  selector: 'app-distribuidor-lst',
  templateUrl: './distribuidor-lst.component.html',
  styleUrls: ['./distribuidor-lst.component.scss']
})
export class DistribuidorLstComponent {
  empresas: Usuario[] = [];
  constructor(private empresaService: EmpresaService) {
    empresaService.all().subscribe({
      next: (resp) => { this.empresas = resp.datos },
      error: (err) => console.error(err)
    })
  }
}
